import { styled } from "@mui/styles";
import Container from "@mui/material/Container";

export const StyledCheckoutForm = styled(Container)(({ theme }) => ({
    '& .OuterGrid': {
        marginTop: 1
    },
    '& #checkoutContactSection .switch': {
        margin: 0
    },
    '& .CoverTransactionFeeSwitch': {
        marginTop: '10px'
    },
    '& .ListRadio': {
        '& .Mui-checked': {
            color: 'white',
        },
        minWidth: '40px',
    },
    '& .PaymentMethodName': {
        '& .MuiTypography-root': { fontSize: '1rem' }
    },
    '& .AmountOptions .MuiGrid-item': {
        padding: '3px',
    },
    '& .PaymentOptions': {
        padding: 0,
        '& .ActiveOption': {
            backgroundColor: theme.palette.primary.main,
            margin: '5px 0',
            color: 'white',

            '& .MethodIcon svg': {
                filter: 'invert(1)'
            }
        },

        '& .InactiveOption': {
            backgroundColor: theme.palette.neutral.light,
            margin: '5px 0',
            color: 'unset',

            '& .MethodIcon svg': {
                filter: 'unset'
            }
        },

        '& .BankTransfer': {
            padding: '20px 50px',
            border: '1px solid #eee',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            [theme.breakpoints.down('md')]: {
                padding: 0,
                border: 'none',
                marginTop: '10px'
            }
        },

        '& .ACHComponent': {
            border: '1px solid #eee', 
            padding: '20px',

            '& .ACHBankDetails': {
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: '10px', 
                backgroundColor: '#eee',
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
    
                '& .AccNumClass': {
                    flexDirection: 'row',
                    gap: '5px'
                }
            }
        },
    }
}));